'use client';

import React from 'react';

import { Svg } from '@ui/svg';
import { cn } from '@/utilities/cn';

export const Rating: React.FC<{
  rating: number;
  variant?: 'sm';
  className?: string;
}> = ({ rating, variant, className }) => {
  let width = 24;
  let height = 22;
  let gap = 'gap-2';

  if (variant === 'sm') {
    width = 16;
    height = 15;
    gap = 'gap-1';
  }

  return (
    <div className={cn('relative', className)}>
      <div className={cn('flex text-gray-500 [&>svg]:md:w-4', gap)}>
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
      </div>

      <div
        className={cn(
          'absolute top-0 left-0 flex overflow-hidden text-[#FFB525]',
          gap,
        )}
        style={{
          clipPath: `inset(0 calc(100% - (${rating} / 5 * 100%)) 0 0)`,
        }}
      >
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
        <Svg id="star" width={width} height={height} />
      </div>
    </div>
  );
};
